// API for Lejar data
import { API_BASE_URL } from "./base";
import { withCsrfHeaders } from "./csrf";

// Helper function to get user department and create headers (no fallback)
const getApiHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userDepartment = user.bahagian;
  if (!userDepartment) throw new Error("bahagian_pemantau diperlukan");
  return {
    "Content-Type": "application/json",
    "X-User-Department": userDepartment,
  };
};

// Update lejar record by no_inbois (for Pelbagai edit mode)
export const apiUpdateLejarByNoInbois = async (no_inbois, lejarData) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/lejar/by-no-inbois/${encodeURIComponent(no_inbois)}`,
      {
        method: "PUT",
        headers: await withCsrfHeaders(getApiHeaders()),
        body: JSON.stringify(lejarData),
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error updating lejar by no_inbois:", error);
    throw error;
  }
};

// Get lejar records by no_akaun
// Get lejar records by no_akaun (NEW ENDPOINT)
export const apiGetLejarByNoAkaun = async (noAkaun) => {
  try {
    const response = await fetch(`${API_BASE_URL}/lejar/noakaun/${encodeURIComponent(noAkaun)}`, {
      method: "GET",
  headers: getApiHeaders(),
      credentials: "include",
      cache: "no-store",
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching lejar by no_akaun:", error);
    throw error;
  }
};

// Get lejar records by kod_harta
export const apiGetLejarByKodHarta = async (kodHarta) => {
  try {
    const response = await fetch(`${API_BASE_URL}/lejar/harta/${encodeURIComponent(kodHarta)}`, {
      method: "GET",
      headers: getApiHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching lejar by kod_harta:", error);
    throw error;
  }
};

// Get lejar records by kod_harta through akaun table relationship
export const apiGetLejarByKodHartaViaAkaun = async (kodHarta) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/lejar/harta-via-akaun/${encodeURIComponent(kodHarta)}`,
      {
        method: "GET",
        headers: getApiHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching lejar by kod_harta via akaun:", error);
    throw error;
  }
};

// Delete lejar record by ID
export const apiDeleteLejar = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/lejar/${id}`, {
      method: "DELETE",
      headers: await withCsrfHeaders(getApiHeaders()),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting lejar record:", error);
    throw error;
  }
};

// Delete lejar by ID and also delete related inbois/inbois_detail with matching no_inbois (matches lejar.no_resit)
export const apiDeleteLejarCascade = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/lejar/${id}/cascade`, {
      method: "DELETE",
      headers: await withCsrfHeaders(getApiHeaders()),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error cascade deleting lejar record:", error);
    throw error;
  }
};

// Delete lejar record(s) by no_inbois
export const apiDeleteLejarByNoInbois = async (no_inbois) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/lejar/by-no-inbois/${encodeURIComponent(no_inbois)}`,
      {
        method: "DELETE",
        headers: await withCsrfHeaders(getApiHeaders()),
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error deleting lejar by no_inbois:", error);
    throw error;
  }
};

// Get lejar records for print by kod_harta
export const apiGetLejarForPrint = async (kodHarta) => {
  try {
    const response = await fetch(`${API_BASE_URL}/lejar/print/${encodeURIComponent(kodHarta)}`, {
      method: "GET",
      headers: getApiHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching lejar for print:", error);
    throw error;
  }
};

// Add new entry to lejar (for Baki Awal)
export const apiTambahLejar = async (lejarData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/lejar`, {
      method: "POST",
      headers: await withCsrfHeaders(getApiHeaders()),
      body: JSON.stringify(lejarData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error creating lejar:", error);
    throw error;
  }
};

// Add new entry to lejar for Terimaan (payment)
export const apiTambahLejarTerimaan = async (lejarData, deptOverride) => {
  try {
    const response = await fetch(`${API_BASE_URL}/lejar/terimaan`, {
      method: "POST",
      headers: await withCsrfHeaders(
        deptOverride
          ? { "Content-Type": "application/json", "X-User-Department": deptOverride }
          : getApiHeaders()
      ),
      body: JSON.stringify(lejarData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error creating lejar terimaan:", error);
    throw error;
  }
};

// Check if a no_resit already exists in lejar
export const apiLejarExistsNoResit = async (no_resit) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/lejar/exists-no-resit/${encodeURIComponent(no_resit)}`,
      {
        method: "GET",
        headers: getApiHeaders(),
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error checking lejar no_resit existence:", error);
    throw error;
  }
};
